export default __webpack_public_path__ + "static/media/KK_P_Right_Top_sCrop.876f3e52.svg";